import { Component } from '@angular/core';

@Component({
    selector: 'icon-icons-library',
    template: `
    <div class="container">
      Viu icons work
    </div>
  `,
    styles: [],
    standalone: false
})
export class IconsLibraryComponent {}
